import { ColorOrCustom, resolveColor } from 'styles';
import { SVG } from '../svg';
import { IconProps } from '../types';

type ChevronUpDownProps = IconProps & {
  upColor?: ColorOrCustom;
  downColor?: ColorOrCustom;
};

export function ChevronUpDownIcon({
  upColor,
  downColor,
  ...props
}: ChevronUpDownProps): JSX.Element {
  return (
    <SVG {...props}>
      <path stroke={upColor ? resolveColor(upColor) : undefined} d="m7 9 5-5 5 5" />
      <path stroke={downColor ? resolveColor(downColor) : undefined} d="m7 15 5 5 5-5" />
    </SVG>
  );
}
